import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiCommonRoutes, ApiEndpoint } from '@app/core/models/api.models';
import { LoggingService } from '@app/core/services/error-logging.service';
import { DisplayToast } from '@app/core/store/states/ui/ui-state.actions';
import { IsPortalApp } from '@app/core/utilities/app.utilities';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { catchError, map, throwError } from 'rxjs';

@Injectable()
export class LoginService {
  private store = inject(Store);
  private http = inject(HttpClient);
  private logger = inject(LoggingService);
  private translate = inject(TranslateService);

  login(email, password) {
    const route: string[] = [ApiCommonRoutes.Session];
    if (!IsPortalApp()) route.unshift(ApiEndpoint.Portal);

    return this.http
      .post(
        route.join('/'),
        {},
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + btoa(`${email}:${password}`),
          },
        },
      )
      .pipe(
        map(() => true),
        catchError((error: any) => {
          if (IsPortalApp()) {
            const textKey = error.status === 401 ? 'portal.creds-error' : 'portal.reset-password-error';
            this.store.dispatch(new DisplayToast({ title: this.translate.instant(textKey), type: 'error' }));
          }
          this.logger.logError('login failed', error, 'error');
          return throwError(() => 'login failed');
        }),
      );
  }
}
